<template>
  <InputSelect
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="languages"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    Lingua
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])

const languages = [{
  id: 'it',
  label: 'Italiano'
}, {
  id: 'en',
  label: 'Inglese'
}, {
  id: 'de',
  label: 'Tedesco'
}, {
  id: 'ru',
  label: 'Russo'
}]

</script>